import classNames from 'classnames';
import React, { useLayoutEffect, useRef } from 'react';
import LoaderSvg from 'images/v5/icons/loader.svg';
import { prefersReducedMotion, revealElement } from 'utils/revealAnimation';
import styles from './Loader.module.scss';
const fadeInReplacingContent = (parent) => {
    const previousChildren = new Set(Array.from(parent.children));
    queueMicrotask(() => {
        if (!parent.isConnected) {
            return;
        }
        Array.from(parent.children)
            .filter((child) => !previousChildren.has(child))
            .forEach(revealElement);
    });
};
function Loader({ size = 'l', noMargin, fullViewport, overlay, }) {
    const wrapRef = useRef(null);
    useLayoutEffect(() => {
        var _a;
        const parent = (_a = wrapRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
        return () => {
            if (!parent || prefersReducedMotion()) {
                return;
            }
            fadeInReplacingContent(parent);
        };
    }, []);
    const wrapClasses = classNames(styles.wrap, styles[size], {
        [styles.noMargin]: noMargin,
        [styles.fullViewport]: fullViewport,
        [styles.overlay]: overlay,
    });
    const loaderClasses = classNames(styles.loader, styles[size], { [styles.svgOverlay]: overlay });
    return (React.createElement("div", { ref: wrapRef, className: wrapClasses },
        React.createElement("span", { className: loaderClasses },
            React.createElement(LoaderSvg, null))));
}
export default Loader;
